var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{attrs:{"disabled":_vm.processing},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.buttonWord))])}
var staticRenderFns = []

export { render, staticRenderFns }